
import { PageProps } from "@inertiajs/inertia";
import { usePage } from "@inertiajs/inertia-vue3";
import {
  mdiCheck,
  mdiClose,
  mdiInformation,
  mdiInformationOutline,
  mdiMessageAlert,
} from "@mdi/js";
import {
  defineComponent,
  reactive,
  computed,
  ref,
  watch,
} from "@vue/runtime-core";
import SvgIcon from "@jamescoyle/vue-icon";
import CollapseTransition from "@ivanv/vue-collapse-transition/src/CollapseTransition";

type Message = {
  text: string;
  uuid: string;
};

type Flash = {
  message: Message | null;
  success: Message | null;
  failure: Message | null;
  warning: Message | null;
};

type MessageWithTitle = {
  title: string;
  message: string;
  is_html?: boolean;
};

interface CustomPageProps extends PageProps {
  flash: Flash | null;
}

export default defineComponent({
  setup() {
    const page = reactive(usePage<CustomPageProps>());
    const flash = computed(() => {
      return page.props.flash;
    });

    const failureMessage = computed((): string | MessageWithTitle => {
      const content = flash.value?.failure?.text;
      if (!content) {
        return "";
      }
      try {
        const object = JSON.parse(content);

        return object;
      } catch (error) {
        return content;
      }
    });

    const show = ref(true);

    watch(
      () => flash.value,
      () => {
        show.value = true;
      },
      {
        deep: true,
      }
    );

    return {
      flash,
      show,
      failureMessage,
      successIcon: mdiCheck,
      infoIcon: mdiInformationOutline,
      dangerIcon: mdiMessageAlert,
      closeIcon: mdiClose,
    };
  },
  components: { SvgIcon, CollapseTransition },
});
